import React, { createContext, useContext, useState } from 'react';

const PracticeContext = createContext();

export const PracticeProvider = ({ children }) => {
  const [selectedPractice, setSelectedPractice] = useState(null);

  return (
    <PracticeContext.Provider value={{ selectedPractice, setSelectedPractice }}>
      {children}
    </PracticeContext.Provider>
  );
};

export const usePractice = () => {
  const context = useContext(PracticeContext);
  if (!context) {
    throw new Error('usePractice must be used within a PracticeProvider');
  }
  return context;
}; 